import { RandomId } from "@swivl-mono/helpers";
import { NodeInterface, NodeType } from "@swivl-mono/types";
import { Checkbox, RadioButtons, Select, SelectableOption } from "@swivl-mono/ui";

import { TagInput, TagInputType } from "../../../../Components/TagInput/TagInput";
import VarsModel from "../../../../Models/Variables/VarsModel.Model";
import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";

const Analytics = {
  Type: "analytics",
  Empty: function () {
    return {
      id: RandomId(6),
      type: NodeType.Analytics,
      platform: "GA",
      event: "swivl-event",
      action: "Swivl-Action",
      title: "Analytics (GA)",
      subtitle: "Swivl Category\nSwivl Action\nSwivl Label",
      category: "Swivl Category",
      label: "Swivl Label",
      onCompleteGoto: null
    };
  },

  PlumbData: function (node: NodeInterface) {
    //     gtag('event', command.action, {
    //   'event_category': command.category,
    //   'event_label': command.label
    // });
    const text =
      node.platform && (node.platform === "GTM" || node.platform === "Amplitude")
        ? node.event
        : node.action + "\n" + node.category + "\n" + node.label;

    const body = VarsModel.replaceVariableNameInString(text, "*", "*");

    return TabNodeLayoutData({
      node: node,
      label: "Analytics",
      title: node.platform,
      body: body,
      baseWidth: 160,
      bodyHeight: 55,
      tabs: [{ id: "onCompleteGoto", source: "onCompleteGoto", target: node.onCompleteGoto }]
    });
  },

  InspectorPanel: class AnalyticsInspectorPanel extends NodePanel {
    render() {
      const options: SelectableOption[] = [
        { value: "GA", label: "Analytics.js (GA)" },
        { value: "GTAG", label: "G Tag (GTAG)" },
        { value: "GTM", label: "Tag Manager (GTM)" },
        { value: "CustomDimension", label: "Custom Dimension" },
        { value: "Amplitude", label: "Amplitude" }
      ];

      var content;
      if (this.props.node.platform && (this.props.node.platform === "GTM" || this.props.node.platform === "Amplitude")) {
        content = (
          <div>
            <TagInput
              label="Event Name"
              type={TagInputType.SingleLine}
              value={this.props.node.event}
              onChange={this.onChange}
              name="event"
              placeholder="Event..."
            />
          </div>
        );
      } else if (this.props.node.platform && this.props.node.platform === "CustomDimension") {
        content = (
          <div key="cd">
            <Select
              label="Type"
              options={[
                { value: "GA", label: "Analytics.js (GA)" },
                { value: "GTAG", label: "G Tag (GTAG)" }
              ]}
              selectedValues={[this.props.node.dimensionType || ""]}
              hideClear
              onChange={(vals) => this.onChangeSwitch("dimensionType", vals[0])}
            />

            {this.props.node.dimensionType === "GTAG" && (
              <>
                <TagInput
                  label="Tracking Id"
                  type={TagInputType.SingleLine}
                  value={this.props.node.trackingId}
                  onChange={this.onChange}
                  name="trackingId"
                  placeholder="Tracking id..."
                />

                <TagInput
                  label="Dimension Index"
                  type={TagInputType.SingleLine}
                  value={this.props.node.dimensionIndex}
                  onChange={this.onChange}
                  name="dimensionIndex"
                  placeholder="Dimension index..."
                />
              </>
            )}

            <TagInput
              label="Dimension Name"
              type={TagInputType.SingleLine}
              value={this.props.node.dimensionName}
              onChange={this.onChange}
              name="dimensionName"
              placeholder="Dimension name..."
            />

            {this.props.node.dimensionType !== "GTAG" && (
              <>
                <TagInput
                  label="Dimension Value"
                  type={TagInputType.SingleLine}
                  value={this.props.node.dimensionValue}
                  onChange={this.onChange}
                  name="dimensionValue"
                  placeholder="Dimension value..."
                />
              </>
            )}
          </div>
        );
      } else {
        content = (
          <div>
            <TagInput
              label="Category"
              type={TagInputType.SingleLine}
              value={this.props.node.category}
              onChange={this.onChange}
              name="category"
              placeholder="Category..."
            />

            <TagInput
              label="Action"
              type={TagInputType.SingleLine}
              value={this.props.node.action}
              onChange={this.onChange}
              name="action"
              placeholder="Action..."
            />

            <TagInput
              label="Label"
              type={TagInputType.SingleLine}
              value={this.props.node.label}
              onChange={this.onChange}
              name="label"
              placeholder="Label..."
            />

            {this.props.node.platform === "GTAG" && (
              <>
                <Checkbox
                  checked={this.props.node.sendDimension}
                  name={"sendDimension"}
                  onCheckedChange={(checked) => this.onChangeSwitch("sendDimension", checked)}
                  label="Send custom dimension"
                />
                {this.props.node.sendDimension && (
                  <>
                    <TagInput
                      label="Dimension Name"
                      type={TagInputType.SingleLine}
                      value={this.props.node.dimensionName}
                      onChange={this.onChange}
                      name="dimensionName"
                      placeholder="Dimension name..."
                    />

                    <TagInput
                      label="Dimension Value"
                      type={TagInputType.SingleLine}
                      value={this.props.node.dimensionValue}
                      onChange={this.onChange}
                      name="dimensionValue"
                      placeholder="Dimension value..."
                    />
                  </>
                )}
              </>
            )}
          </div>
        );
      }

      return (
        <div>
          <div className="panel analytics_panel">
            <InspectorNodeHeader title="Analytics" />
            <label>Analytics Platform</label>
            <RadioButtons options={options} name="platform" value={this.props.node.platform} onChange={this.onChangeUpdateAndRedraw} />
            {content}
            <div className="variableInfo">
              Note: You must install Google Analytics (or GTM, or Amplitude) on your page in order to use analytics events.
            </div>
          </div>
          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};
export default Analytics;
